export default "__VITE_ASSET__0f2670b4__"